import React from 'react'

export const FileTypeIcon = (type: string): JSX.Element | undefined => {

	switch(type) {
	case 'pdf':
		return <i className={'fas fa-file-pdf fa-xl icon-orange center-icon'}/>
	case 'doc':
	case 'docx':
		return <i className={'fas fa-file-word fa-xl  icon-blue center-icon'}/>
	case 'odt':
		return <i className={'fa-solid fa-file-lines fa-xl  icon-blue center-icon'}/>
	case 'img':
	case 'png':
	case 'gif':
	case 'jpg':
	case 'jpeg':
			return <i className={'fa-solid fa-file-image fa-xl  icon-blue center-icon'}/>
	case 'xsl':
	case 'xslt':
	case 'xlsx':
	case 'csv':
		return <i className={'fas fa-file-excel fa-xl icon-green center-icon'}/>
	case 'zip':
		return <i className={'fas fa-file-archive fa-xl icon-orange center-icon'}/>
	case 'pptx':
	case 'ppt':
		return <i className={'fas fa-file-powerpoint fa-xl icon-orange center-icon'}/>
	case 'txt':
	case 'log':
		return <i className={'fas fa-file fa-xl icon-dark-gray center-icon'}/>
	case 'json':
	case 'html':
	case 'ps1':
	case 'java':
	case 'py':
	case 'cs':
	case 'ps2':
	case 'css':
	case 'js':
		return <i className={'fas fa-file-code fa-xl icon-dark-gray avatar center-icon'}/>
	case 'url':
		return <i className={'fas fa-globe fa-xl icon-orange center-icon'}/>
	default:
		return <i className="fa-solid fa-file fa-xl center-icon"/>
	}
}

